import type React from 'react';

import cx from 'classnames';

import { BodySmall } from 'components/typography/Typography';

import { useStyles } from './style';

interface Props {
  message: string;
  classname?: string;
}

const FormErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({ message, classname }: Props) => {
  const { classes } = useStyles();
  return <BodySmall className={cx(classes.errorMessage, classname)}>{message}</BodySmall>;
};

export default FormErrorMessage;
